import React from 'react';
import { View, Text, TextInput, StyleSheet } from 'react-native';

interface DescriptionInputProps {
  value: string;
  onChange: (text: string) => void;
  error?: string;
}

const DescriptionInput: React.FC<DescriptionInputProps> = ({ value, onChange, error }) => (
  <View style={styles.wrapper}>  
    <Text style={styles.label}>Description</Text>
    <TextInput
      style={[styles.input, { height: 100 }]}
      value={value}
      onChangeText={onChange}
      placeholder="Enter charger description"
      placeholderTextColor="#8D8E90"
      multiline
      numberOfLines={5}
    />
    {error ? 
        <Text style={styles.error}>
            {error}
        </Text> : null
    }
  </View>
);

const styles = StyleSheet.create({
  wrapper: { marginBottom: 16 },
  label: { color: '#fff', marginBottom: 4, fontWeight: '600' },
  input: { backgroundColor: '#292D33', color: '#fff', padding: 12, borderRadius: 16 },
  error: { color: 'red', marginTop: 4 },
});

export default DescriptionInput;